import { ReactNode } from 'react';
import { eatingPandaImage } from '@app/assets';
import { ShareButton } from '@app/shared/ui/atoms/Common';
import { Modal } from '@app/shared/ui/organisms/Common';

interface ActivityRewardModalProps {
  children: ReactNode;
  isOpen: boolean;
  setIsOpen: () => void;
  button?: ReactNode;
}

export const ActivityRewardModal = ({
  children,
  isOpen,
  setIsOpen,
  button,
}: ActivityRewardModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      featuredImg={<img src={eatingPandaImage} alt="eating panda" className="w-[134px]" />}
      hiddenTitle="Reward title"
    >
      {children}
      {button ?? <ShareButton type="practices" />}
    </Modal>
  );
};
